export default function handleNavSearch() {
    $('body').on('click', '.js-mobile-open', function () {
        $('.mobile-menu').addClass('mobile-menu--active');
        $('body').addClass('mobile-modal-active');
    }).on('click', '.js-mobile-close', () => {
        $('.mobile-menu').removeClass('mobile-menu--active');
        $('body').removeClass('mobile-modal-active');
    })
}
